import { ClinicalPolicyStatusIndicator } from '@strata/react-status-indicators';
import { type ComponentProps } from 'react';

const StatusMessages = {
    [ClinicalPolicyStatusIndicator.Statuses.EXTREVIEW]: 'Pend. Review',
    [ClinicalPolicyStatusIndicator.Statuses.EXTCHANGE]: 'Change Request',
    [ClinicalPolicyStatusIndicator.Statuses.EXTAPPROVE]: 'Approved',
} as const;

interface PayerPolicyStatusIndicatorProps {
    status: ComponentProps<typeof ClinicalPolicyStatusIndicator>['status'];
}

export const PayerPolicyStatusIndicator = ({ status }: PayerPolicyStatusIndicatorProps) => (
    <ClinicalPolicyStatusIndicator status={status} overrideStatusMessages={StatusMessages} />
);

PayerPolicyStatusIndicator.StatusMessages = StatusMessages;
